<template>
  <footer class="text-left text-lg-start">
    <div class="container p-5">
      <div class="row">
        <div class="col-lg-4 col-md-12 mb-4 mb-md-0">
          <a href="https://www.expertevidence.org/" target="_blank">
            <h5 class="text-uppercase">
              <img width="26px" class="rounded mr-3" src="../assets/logo.png" />
              Expert Evidence
            </h5>
          </a>
          <p>Get legally admissible evidence for the internet</p>
        </div>
        <div class="col-lg-2 col-md-6 mb-4 mb-md-0">
          <h5 class="text-uppercase mb-0">Company</h5>

          <ul class="list-unstyled mt-4">
            <li>
              <a href="#!t">About</a>
            </li>
            <li>
              <a href="#!">Team</a>
            </li>
            <li>
              <a href="#!">Contact</a>
            </li>
            <li>
              <a href="#!">Work with us</a>
            </li>
          </ul>
        </div>
        <div class="col-lg-2 col-md-6 mb-4 mb-md-0">
          <h5 class="text-uppercase mb-0">Enterprise</h5>

          <ul class="list-unstyled mt-4">
            <li>
              <a href="#!">Web Archiving</a>
            </li>
            <li>
              <a href="#!">Doc signing</a>
            </li>
            <li>
              <a href="#!">Evidence management</a>
            </li>
          </ul>
        </div>
        <div class="col-lg-2 col-md-6 mb-4 mb-md-0">
          <h5 class="text-uppercase">App</h5>

          <ul class="list-unstyled mb-0 mt-4">
            <li>
              <a href="/#/getstarted">Get Started</a>
            </li>
            <li>
              <a href="/#/verify">Verify Evidence</a>
            </li>
            <li>
              <a href="/#/getstarted?mode=1">Web Capture</a>
            </li>
            <li>
              <a href="/#/getstarted?mode=2">Sign Documents</a>
            </li>
            <li>
              <a href="#!">About</a>
            </li>
            <li>
              <a href="#!">Privacy</a>
            </li>
          </ul>
        </div>
        <div class="col-lg-2 col-md-6 mb-4 mb-md-0">
          <h5 class="text-uppercase mb-0">Docs</h5>

          <ul class="list-unstyled mt-4">
            <li>
              <a href="#!">How it works</a>
            </li>
            <li>
              <a href="#!">Digital Signature</a>
            </li>
            <li>
              <a href="#!">Web Archive</a>
            </li>
            <li>
              <a href="#!">Documentation</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="text-center p-3" style="background-color: rgba(0, 0, 0, 0.2)">
      © {{ new Date().getFullYear() }} Copyright
      <a class="" href="https://www.expertevidence.org/" target="_blank">expertevidence.org</a>
    </div>
  </footer>
</template>
<script>
export default {
  name: "Footer",
}
</script>
<style scoped>
footer {
  background-color: #242729;
  color: #848d95;
  font-size: 13px;
}

footer a {
  color: #848d95;
  font-size: 13px;
  line-height: 20px !important;
  padding: 4px 0;
  line-height: 1.30769231;
}

footer a:hover {
  color: #e8eaec;
  text-decoration: none;
}

footer p {
  color: #848d95;
  font-size: 13px;
  line-height: 20px !important;
  padding: 4px 0;
  line-height: 1.30769231;
}

footer h5 {
  font-size: 13px;
  text-transform: uppercase;
  font-weight: bold;
  margin-bottom: 12px;
  line-height: 1.30769231;
  color: #bbc0c4;
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue